/**
 * 配置浏览器本地存储的方式，可直接存储对象数组。
 */

import { Storage } from '@ionic/storage';

const store = new Storage();
let isInitialized = false;

/**
 * 初始化 Ionic Storage
 * 需在使用 wsCache 前呼叫此函數
 */
export async function initCache(): Promise<void> {
  if (isInitialized) return;
  await store.create();
  isInitialized = true;
}

export const useCache = () => {
  return {
    wsCache: store
  }
}
